angular
  .module('ordersSubscript')
  .component('ordersSubscript', {
    template: require('./orders-subscript.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function OrdersSubsctionPaymentController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'subscript';
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.showUserView = $rootScope.gShowUserView;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        const toYmd = (value) => {
          if (!value) return '';
          if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
            return value.substring(0, 10);
          }
          const d = value instanceof Date ? value : new Date(value);
          if (Number.isNaN(d.getTime())) return '';
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${y}-${m}-${day}`;
        };

        const startOfToday = () => {
          const d = new Date();
          d.setHours(0, 0, 0, 0);
          return d;
        };

        this.listData = [];
        this.totalCount = 0;
        this.totalPrice = 0;
        this.dateRange = {
          startdate: startOfToday(),
          enddate: startOfToday(),
        };

        this.loadIncome = () => {
          const startDate = toYmd(this.dateRange.startdate);
          const endDate = toYmd(this.dateRange.enddate);
          if (!startDate || !endDate) {
            return;
          }
          $resource(`${APIURL}/wash/subscription_payment/package/admin_subscription_income/${startDate}/${endDate}`)
            .query({}).$promise
            .then((data) => {
              const rows = Array.isArray(data) ? data : [];
              this.listData = rows;
              this.totalCount = rows.length;
              this.totalPrice = rows.reduce((sum, row) => sum + (Number(row.PRICE) || 0), 0);
            })
            .catch((err) => {
              console.error(err);
              this.listData = [];
              this.totalCount = 0;
              this.totalPrice = 0;
              if (err && err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.onDatePick = () => {
          this.loadIncome();
        };

        this.loadIncome();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/subscription/orders-subscript.component.js